<template>
  <v-window v-model="slider">
    <h-items-list
      v-for="category in categories"
      :key="category.id"
      v-bind="category"
      @change="$emit('change')"
    />
  </v-window>
</template>

<script>
  import Configurable from '@/Mixins/Configurable'
  import HItemsList from './ItemsList'

  export default {
    mixins: [
      Configurable,
    ],

    components: {
      HItemsList,
    },

    computed: {
      slide () {
        return this.config('fastMenuEntry') ? 'dishOrder' : 'category'
      },
      slider: {
        get () {
          return this.$store.state.orders.menu[this.slide]
        },
        set (v) {
          this.$store.commit(`orders/menu/${this.slide}`, v)
        },
      },
      categories () {
        return this.$store.state.orders.menu.categories
      },
    },
  }
</script>
